import { gql } from '@apollo/client';

export const ALL_SERVICE_PROVIDER_USERS_FOR_INSIGHT_PAGE = gql`
  query AllServiceProviderUsersForInsightPage($input: UserFilterInput!) {
    users: allServiceProviderUsersForInsightPage(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          createdAt
          id
          updatedAt
          email
          firstName
          lastName
          status
          lastLogin
          contactNumber
          designation
          activities {
            id
          }
          authMetaData {
            id
            duration
          }
          organisations {
            id
            status
            role {
              id
              name
            }
            organisation {
              id
              isServiceProvider
              serviceProvider {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
